import React from 'react'
import Row from '../components/Row'
import NoRecordsFound from '../components/NoRecordsFound'
import LoadingSpinner from '../components/LoadingSpinner';

const RegisteredDevicesList = ({devices, onEdit, onDelete, onSort, sortBy, isSortAsc, isLoading}) => { 
    const headers = [
        {
          key: "name",
          name: "Name",
          width: 2
        },
        {
          key: "os",
          name: "Os",
          width: 2
        },
        {
          key: "osVersion",
          name: "Version",
          width: 1
        },
        {
          key: "model",
          name: "Model",
          width: 2
        },
        {
          key: "deviceType",
          name: "Device Type",
          width: 2
        },
        {
          key: "trackingDevice",
          name: "Tracking",
          width: 1
        },
        {
          key: "edit",
          name: "Edit",
          sortable: false,
          width: 1
        },
        {
          key: "delete",
          name: "Delete",
          sortable: false,
          width: 1
        }
    ]

    const arrow =  isSortAsc ? <span className="glyphicon glyphicon-triangle-bottom" title="Active" /> : <span className="glyphicon glyphicon-triangle-top" title="Inactive" />

    const renderTableHeaders = () => {
        return headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                )
            }
    
            return (
                <th key={key}  onClick={() => onSort(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                        {name} {sortBy === key && arrow }
                    </div>
                </th>
            )
        })
      }


    const renderTableRows = () => {
        if (devices.length) {
            return devices.map(device => {
                const trackingDevice =  device.trackingDevice === true ? <span className="glyphicon glyphicon-ok glyphicon-large grey" /> : <span className="glyphicon glyphicon-remove glyphicon-large faint-grey" />

                const selectedFields = {
                    name: device.name,
                    os: device.os,
                    osVersion: device.osVersion,
                    model: device.model,
                    deviceType: device.deviceType,
                    trackingDevice
                }

                return (
                    <Row
                        key={device._id} 
                        data={selectedFields}
                        onEdit={() => onEdit(device._id)}
                        onDelete={() => onDelete(device)}
                    />
                )
            })
        }

        return <NoRecordsFound />
    }

    return (
        <div className="test-instance-list">
            { isLoading ? <div className="flex-center"><LoadingSpinner /></div> : (
                <table className="table">
                    <thead className="test-instance-details-head">
                    <tr>
                        { renderTableHeaders() }
                    </tr>
                    </thead>
                    <tbody>
                    { renderTableRows() }
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default RegisteredDevicesList
